import script from "./multiLangDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./multiLangDialog.vue?vue&type=script&lang=ts&setup=true"

import "./multiLangDialog.vue?vue&type=style&index=0&id=1f395840&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f395840"]])

export default __exports__